import { render, staticRenderFns } from "./addCountry.vue?vue&type=template&id=1ec4770f&scoped=true&"
import script from "./addCountry.vue?vue&type=script&lang=ts&"
export * from "./addCountry.vue?vue&type=script&lang=ts&"
import style0 from "./addCountry.vue?vue&type=style&index=0&id=1ec4770f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4770f",
  null
  
)

export default component.exports